import { Icons } from './Icons';

export { Icons };
export default Icons;
